'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (ProductImages, $) {
		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.ProductImages = $('[data-product-images]');
			$dom.ProductHero = $('[data-product-hero-image]');
		};

		var ProductImagesInit = function ProductImagesInit(current) {
			var selectedImage = current.attr('data-image-src');
			if (!current.hasClass('active')) {
				$dom.ProductImages.find('li').removeClass('active');
				current.addClass('active');
				$dom.ProductHero.css('background-image', 'url("' + selectedImage + '")');
			}
		};

		var bindUIActions = function bindUIActions() {
			$dom.ProductImages.on('click', 'li', function () {
				ProductImagesInit($(this));
			});
		};

		ProductImages.init = function () {
			cacheDom();
			$(window).on('load', function () {
				bindUIActions();
			});
		};
	})(window.ProductImages = window.ProductImages || {}, _jquery2.default, undefined);
};